<template>
    <div class="col-12 nopads">
        <top-bar
            @onSignInClicked="showLogin"
            @onSearchClicked="searchView"/>
        <alert
            :show="alertVisible"
            :message="message"
            :variant="variant"
            @alertShown=alertShown
            @alertDismiss="alertDismiss"
        />
        <div class="col-12 main-container">
            <div class="col-xl-10 content-container mx-auto">
                <transition name="fade">
                    <login v-if="showLogIn"
                           @loginAdmin="showAdminView"
                           @loginUser="showCampaignView"
                           @alert="showAlert"
                           @close="showMain"
                           @resetClose="showNote">
                    </login>
                </transition>
                <div class="col-12 nopads" v-if="!showLogIn">
                    <bread-crumbs :breadcrumbs="this.breadcrumbs" />
                    <category-feed @onCategorySet="setCategory"/>
                </div>
            </div>
            <footer-area />
        </div>
    </div>

</template>

<script>
import Login from "../components/Login";
import Alert from '../components/Alert'
import {alertMixin} from "../mixins/AlertMixin";
import TopBar from "../components/TopBar";
import FooterArea from "../components/FooterArea";
import BreadCrumbs from "@/components/BreadCrumbs";
import CategoryFeed from "@/components/feed/CategoryFeed";

export default {
    name: "categories-list-view",
    mixins: [alertMixin],
    components: {CategoryFeed, BreadCrumbs, FooterArea, TopBar, Alert, Login},
    data() {
        return {
            showLogIn: false,
            showSearchField: false,
            category: -1,
            note: false,
            breadcrumbs: [
                {
                    text: "breadcrumbs.front_page",
                    translate: true,
                    route: 'main-view',
                    disabled: false,
                    active: false
                },
                {
                    text: "breadcrumbs.categories",
                    translate: true,
                    route: 'teams-list-view',
                    disabled: true,
                    active: true
                },
            ]
        }
    },

    methods: {
        searchView : function () {
            this.showLogIn = false
            this.$router.push({name: 'search-view'})
        },

        showLogin: function () {
            this.showLogIn = true
        },

        showMain: function () {
            this.showLogIn = false
        },

        showTeamsListView: function () {
            this.showLogIn = false
            this.$router.push({name: 'teams-list-view'})
        },

        showNote: function () {
            this.note = true
            this.showAlert(this.$t('login.link_send'), "info")
        },

        alertDismiss: function () {
            if (this.note) {
                this.showLogIn = false
                this.note = false
            }
        },

        setCategory(category) {
            this.category = category
            this.$router.push({name: 'category-organizations-view', params: {id: category}})
        },

        showAdminView: function () {
          this.showLogIn = false
          this.$router.push({name: 'admin-view'})
        },

        showCampaignView: function () {
          this.showLogIn = false
        },
    }
}
</script>

<style scoped>

</style>